var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMonitoringActionStartedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.627 6.18359C11.627 9.22116 9.16452 11.6836 6.12695 11.6836C3.08939 11.6836 0.626953 9.22116 0.626953 6.18359C0.626953 3.14603 3.08939 0.683594 6.12695 0.683594C9.16452 0.683594 11.627 3.14603 11.627 6.18359ZM5.02695 3.09835L8.11216 6.18356L5.02695 9.26877V3.09835Z",
    fill: "#F4BB66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringActionStartedIcon);
export default __webpack_public_path__ + "static/media/monitoring-action-started-icon.5cd52d78d6e64172261875148c9d381e.svg";
export { ForwardRef as ReactComponent };